import React, { Suspense } from 'react';
import { autoChooseComponent } from '@common/utils/brandDiffsUtils';
const StoneModalDialog = React.lazy(() => import('@stone/components/modal/ModalDialog'));
const MocnclerModalDialog = React.lazy(() => import('@moncler/components/modal/ModalDialog'));
const ModalDialog = (props) => {
    return (React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) }, autoChooseComponent({
        MO: React.createElement(MocnclerModalDialog, Object.assign({}, props)),
        ST: React.createElement(StoneModalDialog, Object.assign({}, props, { isLegacy: true })),
    })));
};
export default ModalDialog;
